import React, { useState, useEffect, useRef } from "react";

import styled from "styled-components";

const StyledInput = styled.div`
  margin-bottom: 26px;

  .error-description {
    color: #b00020;
    font-size: 12px;
    height: 16px;
    position: relative;
    > div {
      position: absolute;
      bottom: 0;
      left: 20px;
    }
  }
`;

const StyledLabel = styled.label`
  height: 56px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  font-size: 16px;
  display: block;
  padding: 20px;
  position: relative;
  box-sizing: border-box;
  cursor: text;

  > input {
    border: none;
    background-color: transparent;
    width: 100%;
    &:active,
    &:focus {
      outline: none;
    }
    &:-webkit-autofill {
      background-color: transparent !important;
    }
    &:-internal-autofill-selected {
      background-color: transparent !important;
    }
  }

  > .label-text {
    position: absolute;
    top: 0;
    left: 16px;
    padding: 0 4px 0 4px;
    transform: translate(0, 20px) scale(1);
    color: rgba(0, 0, 0, 0.6);
    transition:
      color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,
      transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    background-color: white;
    cursor: text;
  }
  &.focused > .label-text {
    transform: translate(0, -7px) scale(0.75);
    transform-origin: top left;
  }

  &.input-error {
    border: 1px solid #b00020;
    > .label-text {
      color: #b00020;
    }
  }
`;

const Input = (props) => {
  const [active, setActive] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    if (props.defaultValue) {
      setActive(true);
    }

    if (props.innerRef && inputRef) {
      console.log("Input ref", inputRef);
      props.innerRef(inputRef);
    }
  }, []);

  const onFocus = (e) => {
    console.log("Yeah, we got focus!");
    setActive(true);

    /* Why is this here?
        if (props.onBlur) {
            props.onBlur(e);
        }

         */
  };

  const onBlur = (e) => {
    setActive(false);
    if (props.onBlur) {
      props.onBlur(e);
    }
  };

  let classes = "";
  if (active || props.value) {
    classes += "focused ";
  }

  let error = "";
  if (props.error && !active) {
    classes += "input-error ";
    error = props.error;
  }

  return (
    <StyledInput>
      <StyledLabel className={classes}>
        <div className="label-text">{props.label}</div>
        <input {...props} onFocus={onFocus} onBlur={onBlur} ref={inputRef} />
      </StyledLabel>
      {
        <div className="error-description">
          <div>{error}</div>
        </div>
      }
    </StyledInput>
  );
};

export default Input;
